module.exports = __webpack_public_path__ + "7ecef941ed8b446e2efb9b4e275e1a4c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-7.png
// module id = 3094
// module chunks = 0